import { createFileRoute } from '@tanstack/react-router'
import { Link2Off } from 'lucide-react'
import { StatusCard } from '@/components/StatusCard'

// No token in the path — the patient opened the bare domain rather than their personalised link.
export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  return (
    <StatusCard tone="neutral" icon={<Link2Off className="size-7" />} title="This link looks incomplete">
      Please open the consent link exactly as it was sent to you in your message.
    </StatusCard>
  )
}
